export const routes = [
    { path: '/', redirect: { name: 'dashboard' } },

    {
        path: '*',
        component: require('./components/includes/Error404.vue').default,
        meta: {
            title: 'Error 404',
            requiresAuth: false
        },
    },
    {
        isPage: false,
        name: 'login',
        path: '/login',
        component: require('./components/auth/Login.vue').default,
        meta: {
            title: 'Login',
            requiresAuth: false
        },
    },
    {
        isPage: false,
        name: 'two_factor_auth',
        path: '/two-factor-auth',
        component: require('./components/auth/TwoFactor.vue').default,
        meta: {
            title: 'Two factor authentication',
            requiresAuth: true
        },
    },

    {
        isPage: true,
        name: 'dashboard',
        path: '/dashboard',
        component: require('./components/Dashboard.vue').default,
        meta: {
            title: 'Dashboard',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'players',
        path: '/players',
        component: require('./components/Players.vue').default,
        meta: {
            title: 'Players',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'bet_add',
        path: '/bet-add',
        component: require('./components/Bet.vue').default,
        meta: {
            title: 'Bet add',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'bet_history',
        path: '/game-ledger',
        component: require('./components/BetHistory.vue').default,
        meta: {
            title: 'Game ledger',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'credit_ledger',
        path: '/credit-ledger',
        component: require('./components/CreditLedger.vue').default,
        meta: {
            title: 'Credit ledger',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'winners',
        path: '/winners',
        component: require('./components/Winners.vue').default,
        meta: {
            title: 'Winners',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'draws',
        path: '/draws',
        component: require('./components/Draws.vue').default,
        meta: {
            title: 'Draws',
            requiresAuth: true
        },
    },
    // {
    //     isPage: true,
    //     name: 'all_areas',
    //     path: '/set-by-area',
    //     component: require('./components/AllAreas.vue').default,
    //     meta: {
    //         title: 'Set by area',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'all_regions',
    //     path: '/set-by-region',
    //     component: require('./components/AllRegions.vue').default,
    //     meta: {
    //         title: 'Set by region',
    //         requiresAuth: true
    //     },
    // },
    {
        isPage: true,
        name: 'prizes',
        path: '/prizes',
        component: require('./components/Prizes.vue').default,
        meta: {
            title: 'Prizes',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'daily_results',
        path: '/daily-results',
        component: require('./components/DailyResults.vue').default,
        meta: {
            title: 'Daily results',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'sub_agents',
        path: '/agents',
        component: require('./components/SubAgents.vue').default,
        meta: {
            title: 'Agent',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'featured_numbers',
        path: '/featured-numbers',
        component: require('./components/FeaturedNumbers.vue').default,
        meta: {
            title: 'Featured numbers',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'agent_credits',
        path: '/agent-credits',
        component: require('./components/AgentCredits.vue').default,
        meta: {
            title: 'Load agent credits',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'commission',
        path: '/commission',
        component: require('./components/Commission.vue').default,
        meta: {
            title: 'Commission',
            requiresAuth: true
        },
    },
    // {
    //     isPage: true,
    //     name: 'sales',
    //     path: '/sales',
    //     component: require('./components/Sales.vue').default,
    //     meta: {
    //         title: 'Sales',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'winning_shares',
    //     path: '/winning-shares',
    //     component: require('./components/WinningShares.vue').default,
    //     meta: {
    //         title: 'Winning shares',
    //         requiresAuth: true
    //     },
    // },
    {
        isPage: true,
        name: 'winners_summary_agent',
        path: '/winners-summary-agent',
        component: require('./components/WinnersSummaryAgent.vue').default,
        meta: {
            title: 'Winners summary agent',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'winners_summary_player',
        path: '/winners-summary-player',
        component: require('./components/WinnersSummaryPlayer.vue').default,
        meta: {
            title: 'Winners summary player',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'returns',
        path: '/returns',
        component: require('./components/Returns.vue').default,
        meta: {
            title: 'Returns',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'gcoins_loaded',
        path: '/gems-loaded',
        component: require('./components/Accounting/GcoinsLoaded.vue').default,
        meta: {
            title: 'Gems loaded',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'operators_ledger',
        path: '/operators-ledger',
        component: require('./components/Accounting/OperatorsLedger.vue').default,
        meta: {
            title: 'Operators ledger',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'managers_ledger',
        path: '/managers-ledger',
        component: require('./components/Accounting/ManagerLedger.vue').default,
        meta: {
            title: 'Managers ledger',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'commissions_ledger',
        path: '/commissions',
        component: require('./components/Accounting/Commissions.vue').default,
        meta: {
            title: 'Commissions',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'win_shares',
        path: '/win_shares',
        component: require('./components/Accounting/WinningShares.vue').default,
        meta: {
            title: 'Win shares',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'win_payouts',
        path: '/win_payouts',
        component: require('./components/Accounting/WinningPayouts.vue').default,
        meta: {
            title: 'Winning payouts',
            requiresAuth: true
        },
    },
    // {
    //     isPage: true,
    //     name: 'payout_released',
    //     path: '/payout_released',
    //     component: require('./components/Accounting/PayoutReleased.vue').default,
    //     meta: {
    //         title: 'Payouts released',
    //         requiresAuth: true
    //     },
    // },
    {
        isPage: true,
        name: 'gross_sales',
        path: '/gross-sales',
        component: require('./components/Accounting/GrossSales.vue').default,
        meta: {
            title: 'Gross sales',
            requiresAuth: true
        },
    },
    // {
    //     isPage: true,
    //     name: 'players_ledger',
    //     path: '/players-ledger',
    //     component: require('./components/Accounting/PlayersLedger.vue').default,
    //     meta: {
    //         title: 'Players app ledger',
    //         requiresAuth: true
    //     },
    // },
    {
        isPage: true,
        name: 'gs_by_executive',
        path: '/gross-sales-by-gamehost',
        component: require('./components/Accounting/GSbyExecutive.vue').default,
        meta: {
            title: 'Gross sales by agent',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'gs_by_manager',
        path: '/gross-sales-by-manager',
        component: require('./components/Accounting/GSbyManager.vue').default,
        meta: {
            title: 'Gross sales by manager',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'gs_by_supervisor',
        path: '/gross-sales-by-supervisor',
        component: require('./components/Accounting/GSbySupervisor.vue').default,
        meta: {
            title: 'Gross sales by supervisor',
            requiresAuth: true
        },
    },
    // {
    //     isPage: true,
    //     name: 'gs_by_player',
    //     path: '/gross-sales-by-player',
    //     component: require('./components/Accounting/GSbyPlayer.vue').default,
    //     meta: {
    //         title: 'Gross sales by player',
    //         requiresAuth: true
    //     },
    // },
    {
        isPage: true,
        name: 'gs_by_draw',
        path: '/gross-sales-by-draw',
        component: require('./components/Accounting/GSbyDraw.vue').default,
        meta: {
            title: 'Gross sales by draw',
            requiresAuth: true
        },
    },
    // {
    //     isPage: true,
    //     name: 'gs_by_area',
    //     path: '/gross-sales-by-area',
    //     component: require('./components/Accounting/GSbyArea.vue').default,
    //     meta: {
    //         title: 'Gross sales by area',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'gs_by_region',
    //     path: '/gross-sales-by-region',
    //     component: require('./components/Accounting/GSbyRegion.vue').default,
    //     meta: {
    //         title: 'Gross sales by region',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'games_sales_operation',
    //     path: '/games-sales-operation',
    //     component: require('./components/Accounting/GamesSalesOperation.vue').default,
    //     meta: {
    //         title: 'Games sales operation',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'prize_fund',
    //     path: '/prize-fund',
    //     component: require('./components/Accounting/PrizeFund.vue').default,
    //     meta: {
    //         title: 'Prize fund',
    //         requiresAuth: true
    //     },
    // },
    {
        isPage: true,
        name: 'most_popular',
        path: '/tally-board',
        component: require('./components/MostPopular.vue').default,
        meta: {
            title: 'Tally board',
            requiresAuth: true
        },
    },

    // {
    //     isPage: true,
    //     name: 'cash_in_history',
    //     path: '/cash-in-history',
    //     component: require('./components/CashInHistory.vue').default,
    //     meta: {
    //         title: 'Cash-in history',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'cash_out_history',
    //     path: '/cash-out-history',
    //     component: require('./components/CashOutHistory.vue').default,
    //     meta: {
    //         title: 'Cash-out history',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'gcash_accounts',
    //     path: '/gcash-accounts',
    //     component: require('./components/GcashAccounts.vue').default,
    //     meta: {
    //         title: 'Gcash accounts',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'messages',
    //     path: '/messages',
    //     component: require('./components/Messages.vue').default,
    //     meta: {
    //         title: 'Messages',
    //         requiresAuth: true
    //     },
    // },
    {
        isPage: true,
        name: 'rep_daily_result',
        path: '/report-daily-result',
        component: require('./components/Reports/DailyResult.vue').default,
        meta: {
            title: 'Daily result',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'rep_winners',
        path: '/report-winners',
        component: require('./components/Reports/Winners.vue').default,
        meta: {
            title: 'Winners',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'rep_manager_list',
        path: '/report-gamehost-list',
        component: require('./components/Reports/ManagersList.vue').default,
        meta: {
            title: 'Game host list',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'rep_operators_ledger',
        path: '/report-operators-ledger',
        component: require('./components/Reports/OperatorsLedger.vue').default,
        meta: {
            title: 'Operators ledger',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'rep_manager_com',
        path: '/report-gamehost-commissions',
        component: require('./components/Reports/ManagersCommission.vue').default,
        meta: {
            title: 'Game host Commissions',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'rep_winning_shares',
        path: '/report-winning-shares',
        component: require('./components/Reports/WinningShares.vue').default,
        meta: {
            title: 'Winning shares',
            requiresAuth: true
        },
    },
    // {
    //     isPage: true,
    //     name: 'rep_games_sales',
    //     path: '/report-games-sales-operation',
    //     component: require('./components/Reports/GamesSalesOperation.vue').default,
    //     meta: {
    //         title: 'Games sales operation',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'rep_gcoins_summary',
    //     path: '/report-gcoins-summary',
    //     component: require('./components/Reports/GcoinSummary.vue').default,
    //     meta: {
    //         title: 'Gcoins transaction summary',
    //         requiresAuth: true
    //     },
    // },

    // {
    //     isPage: true,
    //     name: 'online_players',
    //     path: '/online-players',
    //     component: require('./components/OnlinePlayers.vue').default,
    //     meta: {
    //         title: 'Online players',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'commission_released',
    //     path: '/commission-released',
    //     component: require('./components/Accounting/CommissionReleased.vue').default,
    //     meta: {
    //         title: 'Commission released',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'winshare_released',
    //     path: '/winshare-released',
    //     component: require('./components/Accounting/WinshareReleased.vue').default,
    //     meta: {
    //         title: 'Winshare released',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'ckeditor',
    //     path: '/ckeditor',
    //     component: require('./components/CKEditor.vue').default,
    //     meta: {
    //         title: 'CKEditor',
    //         requiresAuth: true
    //     },
    // },
    // {
    //     isPage: true,
    //     name: 'banker_management',
    //     path: '/banker-management',
    //     component: require('./components/BankerManagement.vue').default,
    //     meta: {
    //         title: 'Banker management',
    //         requiresAuth: true
    //     },
    // },
    {
        isPage: true,
        name: 'user_management',
        path: '/system-user',
        component: require('./components/UserManagement.vue').default,
        meta: {
            title: 'System users',
            requiresAuth: true
        },
    },
    {
        isPage: true,
        name: 'agentremittance',
        path: '/agent-remittance',
        component: require('./components/Accounting/AgentRemittance.vue').default,
        meta: {
            title: 'Agent Remittance',
            requiresAuth: true
        },
    },
    // {
    //     isPage: true,
    //     name: 'gamesharing',
    //     path: '/operation-sharing',
    //     component: require('./components/Accounting/GameOperationSharing.vue').default,
    //     meta: {
    //         title: 'Game operation sharing',
    //         requiresAuth: true
    //     },
    // },
    {
        isPage: true,
        name: 'gamesharing',
        path: '/sharing-operation',
        component: require('./components/Accounting/GameSharing.vue').default,
        meta: {
            title: 'Game operation sharing',
            requiresAuth: true
        },
    },
    // {
    //     isPage: true,
    //     name: 'raffle',
    //     path: '/raffle',
    //     component: require('./components/Raffle/Raffle.vue').default,
    //     meta: {
    //         title: 'Raffle',
    //         requiresAuth: true
    //     },
    // },
    {
        isPage: true,
        name: 'rewards',
        path: '/Rewards',
        component: require('./components/Raffle/Rewards.vue').default,
        meta: {
            title: 'Rewards',
            requiresAuth: true
        },
    },



];